// felyfit-leggings landing JS -- v5.3
var _flv=5.3;
window.openCartDrawerVyta = window.openCartDrawerVyta || function(data) {
  var cd = document.querySelector('cart-drawer');
  if (!cd) return;
  if (!document.getElementById('_vyta_drawer_fix')) {
    var s = document.createElement('style');
    s.id = '_vyta_drawer_fix';
    s.textContent = 'cart-drawer:not(.active) .cart-drawer__overlay, cart-drawer:not(.active) #CartDrawer-Overlay { pointer-events: none !important; visibility: hidden !important; } .cart-drawer .drawer__inner{display:flex!important;flex-direction:column!important;height:100%!important;overflow:hidden!important} .cart-drawer .cart-drawer__body{flex:1 1 0%!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;overscroll-behavior:contain!important;min-height:0!important} .cart-drawer .drawer__footer{flex-shrink:0!important}';
    document.head.appendChild(s);
  }
  cd.classList.remove('is-empty');
  if (typeof cd.renderContents === 'function') cd.renderContents(data);
  requestAnimationFrame(function() { if (typeof cd.open === 'function') cd.open(); });
};

(function () {
  var root = document.querySelector('.landing-felyfit-leggings');
  if (!root) return;

  // SCROLL REVEAL — va antes del early return para ejecutar siempre
  if ('IntersectionObserver' in window) {
    var flpObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); flpObs.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    root.querySelectorAll('.flp-reveal').forEach(function (el) { flpObs.observe(el); });
  } else {
    root.querySelectorAll('.flp-reveal').forEach(function (el) { el.classList.add('visible'); });
  }

  // SIZE CHART MODAL
  var sizeBtn = root.querySelector('.flp-size-guide');
  var modal = root.querySelector('.flp-size-modal-overlay');
  var closeBtn = root.querySelector('.flp-size-modal-close');
  if (sizeBtn && modal) {
    sizeBtn.addEventListener('click', function () { modal.classList.add('open'); });
    if (closeBtn) closeBtn.addEventListener('click', function () { modal.classList.remove('open'); });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.classList.remove('open'); });
  }

  // VARIANT / SELECT SYNC
  var form = root.querySelector('.flp-buy-form');
  if (!form) return;
  var variantInput = form.querySelector('input[name="id"]');
  var selects = form.querySelectorAll('select[data-option]');
  var variantData = [];
  try {
    var dataEl = root.querySelector('script[id="fl-variant-data"]') || root.querySelector('script[data-fl-variants]');
    if (dataEl) variantData = JSON.parse(dataEl.textContent);
  } catch (e) {}

  // COLOR SWATCH
  var colorLabel = root.querySelector('#fl-color-label');
  var swatches = root.querySelectorAll('.flp-swatch');
  swatches.forEach(function (sw) {
    sw.addEventListener('click', function () {
      var val = sw.getAttribute('data-value');
      var optIdx = sw.getAttribute('data-opt');
      swatches.forEach(function (s) {
        var same = s.getAttribute('data-opt') === optIdx;
        if (same) { s.classList.toggle('is-active', s === sw); s.setAttribute('aria-pressed', s === sw ? 'true' : 'false'); }
      });
      if (colorLabel) colorLabel.textContent = ': ' + val;
      selects.forEach(function (sel) {
        if (sel.getAttribute('data-option') === optIdx) {
          for (var i = 0; i < sel.options.length; i++) {
            if (sel.options[i].value === val) { sel.selectedIndex = i; break; }
          }
          sel.dispatchEvent(new Event('change'));
        }
      });
    });
    sw.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sw.click(); }
    });
  });

  // SIZE BUTTONS
  var sizeBtns = root.querySelectorAll('.flp-size-btn');
  sizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var val = btn.getAttribute('data-value');
      var optIdx = btn.getAttribute('data-opt');
      sizeBtns.forEach(function (b) {
        if (b.getAttribute('data-opt') === optIdx) b.classList.toggle('is-active', b === btn);
      });
      var sizeLabel = root.querySelector('#fl-size-label-' + optIdx);
      if (sizeLabel) sizeLabel.textContent = ': ' + val;
      selects.forEach(function (sel) {
        if (sel.getAttribute('data-option') === optIdx) {
          for (var i = 0; i < sel.options.length; i++) {
            if (sel.options[i].value === val) { sel.selectedIndex = i; break; }
          }
          sel.dispatchEvent(new Event('change'));
        }
      });
    });
  });

  function syncVariant() {
    if (!variantData.length) return;
    var chosen = Array.from(selects).map(function (s) { return s.value; });
    var match = variantData.find(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    });
    var btn = form.querySelector('.flp-atc-btn');
    var unavailEl = form.querySelector('.flp-unavailable');
    if (match) {
      if (variantInput) variantInput.value = match.id;
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? (btn.getAttribute('data-label') || 'AGREGAR AL CARRITO') : 'AGOTADO';
      }
      if (unavailEl) unavailEl.style.display = 'none';
    } else {
      if (btn) { btn.disabled = true; btn.textContent = 'NO DISPONIBLE'; }
      if (unavailEl) unavailEl.style.display = 'block';
    }
  }
  selects.forEach(function (s) { s.addEventListener('change', syncVariant); });
  syncVariant();

  // ATC -- AJAX + cart drawer RIGHT side (capture:true intercepts before Kaching)
  var flAtcBtn = form.querySelector('.flp-atc-btn');
  if (flAtcBtn) {
    flAtcBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (flAtcBtn.disabled) return;
      var variantId = variantInput ? variantInput.value : null;
      if (!variantId) return;
      var orig = flAtcBtn.textContent;
      flAtcBtn.disabled = true;
      flAtcBtn.textContent = 'Agregando...';
      fetch('/cart/add.js?kaching_bundles=true', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'] })
      }).then(function(r) { return r.json(); }).then(function(data) {
        flAtcBtn.textContent = 'Agregado!';
        window.openCartDrawerVyta(data);
        setTimeout(function() { flAtcBtn.textContent = orig; flAtcBtn.disabled = false; }, 2500);
      }).catch(function() {
        flAtcBtn.textContent = 'Error -- intenta de nuevo';
        flAtcBtn.disabled = false;
        setTimeout(function() { flAtcBtn.textContent = orig; }, 3000);
      });
    }, true); // capture:true -- fires before Kaching bubble listeners
  }

  // REVIEW CAROUSEL
  var flpRevCur = 0, flpRevTot = 5;
  var flpTrack = document.getElementById('flpRevTrack');
  var flpDots = root.querySelectorAll('.flp-rev-dot');
  window.flpGoRev = function (n) {
    flpRevCur = (n + flpRevTot) % flpRevTot;
    if (flpTrack) flpTrack.style.transform = 'translateX(-' + (flpRevCur * 100) + '%)';
    flpDots.forEach(function (d, i) { d.classList.toggle('flp-rev-dot--on', i === flpRevCur); });
  };
  setInterval(function () { window.flpGoRev(flpRevCur + 1); }, 5500);

})();
